import { useState, type InputHTMLAttributes } from "react";
import eyeSvg from "../assets/eye.svg";
import eyeSlashSvg from "../assets/eye-slash.svg";

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  type?: "text" | "email" | "password";
  error?: string;
}

export function Input({ type = "text", error, className = "", ...props }: InputProps) {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";
  const inputType = isPassword && showPassword ? "text" : type;

  return (
    <div className="flex flex-col gap-1.5 w-full">
      <div
        className={`flex items-center gap-2 h-[51px] rounded-2xl border px-4 bg-bg-primary ${
          error ? "border-input-stroke-error" : "border-stroke-primary"
        } ${className}`}
      >
        <input
          type={inputType}
          className="flex-1 bg-transparent outline-none text-base font-medium leading-[1.2] text-text-primary placeholder:text-text-tertiary min-w-0"
          {...props}
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="shrink-0"
            aria-label="Toggle password visibility"
          >
            <img
              src={showPassword ? eyeSvg : eyeSlashSvg}
              alt=""
              width={24}
              height={24}
            />
          </button>
        )}
      </div>
      {error && (
        <p className="text-xs font-medium leading-[1.2] text-input-hint-error">{error}</p>
      )}
    </div>
  );
}
